import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaFileMedical, FaHandsHelping , FaGraduationCap, FaBuilding, FaClipboardList, FaCalendarAlt, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/img/Logo_MiLugar_Simple.png'

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Mi Lugar" />
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/temperley" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaBuilding className="nav-icon" /> Sede Temperley
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/glew" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaBuilding className="nav-icon" /> Sede Glew
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/cet" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaGraduationCap className="nav-icon" /> CET
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/cd" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaHandsHelping  className="nav-icon" /> CD
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/ObrasSociales" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaFileMedical className="nav-icon" /> Obras Sociales
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/tratamientos" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaClipboardList className="nav-icon" /> Tratamientos
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/actividades" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaCalendarAlt className="nav-icon" /> Actividades
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contacto" className="nav-link" onClick={() => setMenuOpen(false)}>
              <FaEnvelope className="nav-icon" /> Contacto
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
